exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sermon-player-wrap[data-v-54490263] {\n  background-color: #232323;\n  color: white;\n  border-bottom: 1px solid rgba(155, 155, 155, 0.16);\n  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.05);\n}\n.sermon-player-wrap .sermon-player[data-v-54490263] {\n  width: 100%;\n}\n.sermon-title h2[data-v-54490263] {\n  color: white !important;\n}", ""]);

// exports
